import React from 'react';
import $ from '../../../common/AjaxRequest';
import { Modal, Button, Table, message } from 'antd';
import API_URL from '../../../common/url';
import ExportUtil from '../../../common/ExportUtil';
import moment from 'moment';

const Config = {
    //非项目因素
    factorNonInv: {
        type: 'factorNonInv',
        url: API_URL.user.queryFactorNonInvList,
    },
    //项目因素
    factorInv: {
        type: 'factorInv',
        url: API_URL.user.queryFactorInvList,
    }
}

class VacantModal extends React.Component {
    state = {
        visible: false,
        data: [],
        params: {},
        pagination: {
            pageSize: 15,
            current: 1,
        },
        loading: false,
        config: {},
    };

    loadData = record => {
        const { userId, time } = record;
        const { config } = this.state;
        const options = {
            url: config.url,
            data: {
                yearMonth: time.replace('-', ''),
                userId,
            },
            dataType: 'json',
            doneResult: (res => {
                const { list, totalCount } = res;
                const { pagination } = this.state;
                pagination.total = totalCount;
                this.setState({
                    data: list,
                    pagination,
                    loading: false,
                });
            }),
            errorResule: (() => {
                this.setState({
                    loading: false,
                });
            }),
        };
        $.sendRequest(options);
    };

    show = (record, type) => {
        this.setState({
            visible: true,
            params: { ...record },
            config: Config[type],
        }, () => {
            this.loadData(record);
        });
    };

    hide = () => {
        this.setState({
            visible: false,
        });
    };


    getColumns = () => {
        const { config } = this.state;
        let columns = [];
        if (config.type === 'factorNonInv') {
            columns = [{
                title: '序号',
                dataIndex: 'index',
                key: 'index',
                width: 80,
            }, {
                title: '涉及因素',
                dataIndex: 'factorShow',
                key: 'factorShow',
                width: 120,
            }, {
                title: '发生次数',
                dataIndex: 'factorCount',
                key: 'factorCount',
                width: 100,
            }, {
                title: '离职日期',
                dataIndex: 'leftTime',
                key: 'leftTime',
                width: 120,
            }, {
                title: '产假空余FTE',
                dataIndex: 'maternityLeaveIdleFte',
                key: 'maternityLeaveIdleFte',
                width: 120,
            }, {
                title: '事假空余FTE',
                dataIndex: 'personalLeaveIdleFte',
                key: 'personalLeaveIdleFte',
                width: 120,
            }, {
                title: '病假空余FTE',
                dataIndex: 'sickLeaveIdleFte',
                key: 'sickLeaveIdleFte',
                width: 120,
            }, {
                title: '试用期空余FTE',
                dataIndex: 'probationaryPeriodIdleFte',
                key: 'probationaryPeriodIdleFte',
                width: 120,
            }]
        } else {
            columns = [{
                title: '涉及因素',
                dataIndex: 'factorShow',
                key: 'factorShow',
                width: 120,
            }, {
                title: 'JDE主项目号',
                dataIndex: 'mainJdeCode',
                key: 'mainJdeCode',
                width: 120,
            }, {
                title: '项目简称',
                dataIndex: 'investigationName',
                key: 'investigationName',
                width: 120,
            }, {
                title: '项目阶段',
                dataIndex: 'investigationStageName',
                key: 'investigationStageName',
                width: 120,
            }, {
                title: '项目进展',
                dataIndex: 'investigationProgress',
                key: 'investigationProgress',
                width: 120,
            }, {
                title: 'PM工号',
                dataIndex: 'mainPmCode',
                key: 'mainPmCode',
                width: 120,
            }, {
                title: 'PM姓名',
                dataIndex: 'mainPmName',
                key: 'mainPmName',
                width: 80,
            }, {
                title: '项目角色',
                dataIndex: 'roleCode',
                key: 'roleCode',
                width: 80,
            }, {
                title: '中心名称',
                dataIndex: 'investigationSiteName',
                key: 'investigationSiteName',
                width: 120,
            }, {
                title: '科室',
                dataIndex: 'departmentName',
                key: 'departmentName',
                width: 100,
            }, {
                title: '项目计划FTE',
                dataIndex: 'planFte',
                key: 'planFte',
                width: 100,
            }, {
                title: '项目确认FTE',
                dataIndex: 'confirmFte',
                key: 'confirmFte',
                width: 100,
            }, {
                title: '偏差',
                dataIndex: 'fteDeviation',
                key: 'fteDeviation',
                width: 100,
            }, {
                title: '非项目确认FTE',
                dataIndex: 'nonInvConfirmFte',
                key: 'nonInvConfirmFte',
                width: 100,
            }, {
                title: '中心计划入组数',
                dataIndex: 'planRandom',
                key: 'planRandom',
                width: 120,
            }, {
                title: '中心实际入组数',
                dataIndex: 'actualRandom',
                key: 'actualRandom',
                width: 120,
            }, {
                title: '中心是否取消',
                dataIndex: 'siteIsCancelShow',
                key: 'siteIsCancelShow',
                width: 120,
            }, {
                title: '实际site启动日期',
                dataIndex: 'siteStartTimeStr',
                key: 'siteStartTimeStr',
                width: 120,
            }]
        }
        return columns
    }

    getDataSource = () => {
        const { data, pagination } = this.state;
        const dataSource = [];
        (data || []).map((el, index) => {
            dataSource.push({
                index: ((pagination.current - 1) || 0) * 15 + index + 1,
                ...el,
            });
        });
        return dataSource;
    }

    dataExport = params => {
        const { userId, time } = params;
        const { config } = this.state;
        const newParams = {
            yearMonth: time.replace('-', ''),
            userId,
            type: config.type,
        }
        ExportUtil.export(newParams, null, API_URL.user.exportVacantRateFactorByUserId);
    }

    handleTableChange = pagination => {
        this.setState({
            pagination,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { visible, loading, pagination, params, config } = this.state;
        const { employeeCode, userCompellation, time } = params;
        return (
            <Modal
                title={config.type === 'factorNonInv'?"非项目因素详情":"项目因素详情"}
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                width={config.type === 'factorNonInv' ? "1000px" : "1400px"}
                bodyStyle={{ maxHeight: 600 }}
                footer={<Button key="back" type="ghost" size="large" onClick={this.hide}>关闭</Button>}
            >
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', margin: '10px 20px', alignItems: 'center' }}>
                        <div style={{ textAlign: 'center' }}>
                            工号：{employeeCode}&nbsp;&nbsp;|&nbsp;&nbsp;姓名：{userCompellation}&nbsp;&nbsp;|&nbsp;&nbsp;时间：{time}
                        </div>
                        <Button key="export" type="primary" onClick={() => this.dataExport(params)}>导出</Button>
                    </div>
                    <div style={{ margin: '0px 25px' }}>
                        <Table
                            columns={this.getColumns()}
                            dataSource={this.getDataSource()}
                            loading={loading}
                            pagination={pagination}
                            onChange={this.handleTableChange}
                            scroll={{ x: config.type === 'factorNonInv'?200:1000, y: 350 }}
                        />
                    </div>
                </div>
            </Modal>
        );
    }
}

export default VacantModal;



// WEBPACK FOOTER //
// ./src/components/user/userEfficiency/VacantModal.js